import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-icon"]

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'VIcon',
  props: {
  icon: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props

const isIconify = computed(() => {
  return props.icon && props.icon.indexOf(':') !== -1
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", { key: __props.icon }, [
    (isIconify.value)
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          "aria-hidden": "true",
          class: "iconify",
          "data-icon": __props.icon
        }, null, 8, _hoisted_1))
      : (_openBlock(), _createElementBlock("i", {
          key: 1,
          "aria-hidden": "true",
          class: _normalizeClass(__props.icon)
        }, null, 2))
  ]))
}
}

})